const toSafeEggCount = (eggCount) => {
	const parsed = Number(eggCount);
	if (!Number.isFinite(parsed) || parsed < 0) return 0;
	return Math.round(parsed);
};

const formatDozenCount = (eggCount) => {
	const dozens = toSafeEggCount(eggCount) / 12;
	return Number.isInteger(dozens) ? `${dozens}` : `${dozens.toFixed(2).replace(/\.?0+$/, "")}`;
};

export const formatEggQuantity = (eggCount) => {
	const safeEggCount = toSafeEggCount(eggCount);
	const dozenCount = safeEggCount / 12;
	const dozenLabel = dozenCount === 1 ? "dozen" : "dozens";
	const eggLabel = safeEggCount === 1 ? "egg" : "eggs";

	return `${formatDozenCount(safeEggCount)} ${dozenLabel} (${safeEggCount} ${eggLabel})`;
};
